module.exports = __webpack_public_path__ + "static/media/epargn.89c90c66.svg";